module.exports = __webpack_public_path__ + "img/chat-details9.2741101a.png";